import i18n from 'i18n';

import { Talent, ReportReasonsEnum } from '@libs/graphql-types';
import { OptionType } from '@libs/ui/components/form/select';

export const REPORT_TALENT_MODAL_ID = 'ReportTalentModal';

export type ReportTalentModalData = {
  talent: Partial<Talent>;
};

// Options per Figma spec - using GraphQL enum values
export const REPORT_TALENT_REASONS: OptionType[] = [
  {
    value: ReportReasonsEnum.DiscriminationHateSpeech,
    text: i18n.t('viewProfile.report.reasons.discrimination', {
      ns: 'talentProfile',
    }),
  },
  {
    value: ReportReasonsEnum.InappropriateBehavior,
    text: i18n.t('viewProfile.report.reasons.inappropriate', {
      ns: 'talentProfile',
    }),
  },
  {
    value: ReportReasonsEnum.Harassment,
    text: i18n.t('viewProfile.report.reasons.harassment', {
      ns: 'talentProfile',
    }),
  },
  {
    value: ReportReasonsEnum.SpamFakeProfile,
    text: i18n.t('viewProfile.report.reasons.spam', { ns: 'talentProfile' }),
  },
  {
    value: ReportReasonsEnum.Other,
    text: i18n.t('viewProfile.report.reasons.other', { ns: 'talentProfile' }),
  },
];
